import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const bootstrap = useCallback(async () => {
    const t = localStorage.getItem("brokenrp_token");
    if (!t) {
      setReady(true);
      return;
    }
    try {
      const u = await api.me();
      setUser(u);
    } catch {
      localStorage.removeItem("brokenrp_token");
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const setSession = ({ token, user }) => {
    localStorage.setItem("brokenrp_token", token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("brokenrp_token");
    setUser(null);
  };

  const refreshMe = async () => {
    try {
      const u = await api.me();
      setUser(u);
    } catch {}
  };

  return (
    <AuthCtx.Provider value={{ user, ready, setSession, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
